import { CoreEnums } from '@/utils/domain/constants';

export const APP_KIND_ODATA_FILTER = `kind eq ${CoreEnums.AppKind.App}`;

export const APPS_LAUNCHPAD_ACTIVE_FILTER = `isActive eq true and ${APP_KIND_ODATA_FILTER}`;

/** Belt-and-suspenders: `/app/*` is Apps-only in API; Sites live under `/site/*`. */
export function withAppKindFilter(filter) {
  const raw = filter == null ? '' : String(filter).trim();
  if (!raw) return APP_KIND_ODATA_FILTER;
  if (/\bkind\s+eq\s+\d+/i.test(raw)) return raw;
  return `(${raw}) and ${APP_KIND_ODATA_FILTER}`;
}
